import { TolerantTouchButton } from '@chiroup/components/TolerantTouchButton';
import React from 'react';
import type { SoftSurveyMeta } from './types';

export const SoftSurveyIntro: React.FC<{
  meta: SoftSurveyMeta;
  language: 'en' | 'es';
  primaryColor: string;
  onStart: () => void;
  eyebrow?: string;
  startLabel?: string;
}> = ({ meta, language, primaryColor, onStart, eyebrow, startLabel }) => (
  <div
    className="rounded-3xl overflow-hidden p-6 sm:p-8 dark:ring-1 dark:ring-white/10"
    style={{ backgroundColor: `${primaryColor}12` }}
  >
    <p className="text-xs font-semibold uppercase tracking-wider" style={{ color: primaryColor }}>
      {eyebrow ?? (language === 'es' ? 'Cuestionario' : 'Survey')}
    </p>
    <h1 className="mt-1 text-2xl sm:text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
      {meta.title}
    </h1>
    {meta.subtitle && (
      <p className="mt-2 text-sm text-gray-600 dark:text-gray-300 max-w-prose">{meta.subtitle}</p>
    )}
    {meta.startMessage && (
      <p className="mt-4 text-base text-gray-700 dark:text-gray-200 max-w-prose">
        {meta.startMessage}
      </p>
    )}
    <TolerantTouchButton
      onPress={onStart}
      className="mt-6 inline-flex items-center justify-center rounded-full px-7 py-3 text-sm font-semibold text-white active:scale-[0.98] transition-transform"
      style={{ backgroundColor: primaryColor }}
    >
      {startLabel ?? (language === 'es' ? 'Empezar' : 'Get started')}
    </TolerantTouchButton>
  </div>
);
